/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
import e from"../core/has.js";function o(o){return!!e(`enable-feature:${o}`)}const r=()=>o("force-wosr"),t=()=>o("disable-context-navigation");export{t as disableContextNavigation,r as enableWebStyleForceWOSR,o as hasEnableFeature};
